import React from 'react';
import { useI18n } from '../utils/i18n';

const CommentFields = ({ encuesta, setUserData }) => {
  const t = useI18n();
  // const [input,setInput]=useState();
  // const keyboard =useRef();
  return (
    <>
      <div style={{ fontSize: '18px' }} className={'pregunta'}>
        <label className={'preguntaComentario'}>
          {t(encuesta.strings.titleComments)}
        </label>
      </div>
      <div className={'pregunta caja'}>
        <textarea
          id="qwerty-mod"
          onChange={(ev) => setUserData({ comment: ev.target.value })}
          className={'input'}
        >
        </textarea>
      </div>
    </>
  );
};

export default CommentFields;
